import React from "react";

const pinBtn = (props) => {
    if (props.type != "btn") {
        return (
            <div
                onClick={props.clickHandler}
                className=' m-2 flex h-[75px] w-[75px] cursor-pointer items-center  justify-center rounded-full border-2  border-white text-center     text-4xl font-light'
            >
                <a
                    data-val={props.btnVal}
                    className='flex h-full w-full items-center justify-center text-white'
                >
                    {props.btnVal}
                </a>
            </div>
        );
    }
    if (props.btnVal === "Login") {
        return (
            <div
                className=' bg-blue m-2 flex h-[75px] w-[75px] cursor-pointer items-center  justify-center rounded-full border-2  border-white bg-[#0080a7]	text-center  text-xl lowercase'
                onClick={props.clickHandler}
            >
                <div>
                    <button type='submit' className='text-white'>
                        {props.btnVal}
                    </button>
                </div>
            </div>
        );
    } else {
        return (
            <div
                className=' bg-blue m-2 flex h-[75px] w-[75px] cursor-pointer items-center  justify-center rounded-full border-2  border-white bg-[#0080a7]	text-center  text-xl lowercase'
                onClick={props.clickHandler}
            >
                <div>
                    <a className='text-white'>{props.btnVal}</a>
                </div>
            </div>
        );
    }
};

export default pinBtn;
